import React from 'react';
import Loader from '@gr-monorepo/common/public/ui/Loader';
import { Wrapper } from 'features/shared/Loader/elements';

const LoaderComponent = () => (
  <Wrapper data-testid="main-layout-loader">
    <Loader size={32} />
  </Wrapper>
);

export default LoaderComponent;
